import React, { useEffect } from "react";
import Navbar from "../components/Navbar.js";
import NavbarFixed from "../components/Navbar-Fixed.js";
import { Link, NavLink } from "react-router-dom";

// components
import LoginForm from "../components/Login";
import NavbarNew from "../components/Navbar-New.js";
import FooterNew from "../components/Footer-New.js";


export default function Login(props) {
  return (
    <div>
    
      {/* <NavbarNew /> */}
      <div className="auth_wrapper">
        <LoginForm />
      </div>
      {/* <FooterNew /> */}
      {/* <NavbarFixed /> */}
    </div>
  );
}
